import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from 'src/app/modal/confirm-modal/confirm-modal.component';
import { DataService } from 'src/app/services/data.service';
import { HttpClient } from '@angular/common/http';
import { ToastService } from 'src/app/services/toast.service';
import { CurrentUserService } from 'src/app/services/current-user.service';

@Component({
    selector: 'app-addmapdata',
    templateUrl: './addmapdata.component.html',
    styleUrls: ['./addmapdata.component.scss'],
    standalone: false
})
export class AddmapdataComponent implements OnInit {
  addmapdata: FormGroup;
  map_name: string = '';
  selectedFile: File | undefined;
  selectedJsonFile: File | undefined;
  fileError = false;
  submitted: boolean = false;
  isLoading: boolean = false;
  isUploaded: boolean = false;
  user_id: any;

  mapGenreList = [
    { label: 'Science Fiction & Science Fantasy (Traveller, etc)' },
    { label: 'Fantasy (Dungeons & Dragons, etc)' },
    { label: 'Modern & Horror (Call of Cthulhu, etc)' }
  ];

  constructor(
    private formBuilder: FormBuilder,
    private dataserv: DataService,
    public activeModal: NgbActiveModal,
    private http: HttpClient,
    private toastService: ToastService,
    private privateXY: NgbModal,
    private currentUserService: CurrentUserService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.currentUserService.currentUser.subscribe((data) => {
      if (data) {
        this.user_id = Number(data.id);
        this.cdr.detectChanges();
      }
    });
    this.addmapdata = this.formBuilder.group({
      map_name: ['', [Validators.required]],
      map_genre: [null, [Validators.required]],
      map_file: ['', [Validators.required]],
      json_file: ['', [Validators.required]],
    });
  }

  handleFileInput(event: any) {
    this.selectedFile = event.target.files[0];
  }

  handleJsonFileInput(event: any) {
    this.selectedJsonFile = event.target.files[0];
  }

  onSubmit() {
    this.submitted = true;
    if (!this.addmapdata.valid) {
      this.addmapdata.markAllAsTouched();
      return;
    }
    if (this.selectedFile && this.selectedJsonFile && this.addmapdata.valid) {
      this.isLoading = true;
      var formnewData: FormData = new FormData();
      formnewData.append('map_name', this.addmapdata.value.map_name);
      if (this.addmapdata.value.map_genre) {
        formnewData.append('map_genre', this.addmapdata.value.map_genre);
      }
      formnewData.append('map_file', this.selectedFile);
      formnewData.append('json_file', this.selectedJsonFile);
      formnewData.append('user_id', this.user_id);
      // Here you can perform further actions like sending the formData to the server
      this.dataserv.createmap(formnewData).subscribe(
        (res) => {
          if (res) {
            this.isUploaded = true;
            this.toastService.showSuccess(
              'map added succussfully !!!',
              'success',
            );
            this.isLoading = false;
            // Reload the list
            this.closemodel(res);
          }
        
          this.cdr.detectChanges();},
        (error) => {
          this.isLoading = false;
          this.closemodel(null);
          const modalRef = this.privateXY.open(ConfirmModalComponent, {
            centered: true,
            size: 'md',
            backdrop: 'static',
          });
          modalRef.componentInstance.icon = 'error';
          modalRef.componentInstance.showCancel = false;
          modalRef.componentInstance.title = 'Upload Failed';
          modalRef.componentInstance.message = error.status
            ? `An error occurred during upload (code ${error.status}). Please contact support@worldtumbler.com.`
            : 'An error occurred during upload. Please contact support@worldtumbler.com.';
          modalRef.componentInstance.confirmLabel = 'OK';
          modalRef.componentInstance.confirmVariant = 'theme';
          modalRef.componentInstance.confirmClick.subscribe(() => modalRef.close());
        
          this.cdr.detectChanges();},
      );
    }
  }

  closemodel(res) {
    this.activeModal.close(res);
  }
}
